<template>
  <div class="change-user-name detail-item" v-if="editingData">

    <div class="head"><b>入替社員氏名</b></div>
    <div class="data">
      <p>{{ editingData.change_user_name ? editingData.change_user_name : '-'}}</p>
      <p class="current-data" v-if="currentData?.name">{{ currentData.name }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import OptionConst from '@/const/Option';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
      OptionConst
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
